/**
 * Navigation System
 * Handles mobile menu toggle, accordion, and body scroll lock
 */

(function() {
    'use strict';

    // DOM Elements
    const mobileToggle = document.querySelector('.mobile-menu-toggle');
    const mobileToggleHeader = document.querySelector('.mobile-menu-toggle-header');
    const navMenu = document.querySelector('.nav-menu');
    const mobileOverlay = document.querySelector('.mobile-overlay');
    const navItemsWithDropdown = document.querySelectorAll('.nav-item.has-mega-menu, .nav-item.has-dropdown');
    const body = document.body;

    // State
    let isMobileMenuOpen = false;

    /**
     * Toggle Mobile Menu
     */
    function toggleMobileMenu() {
        isMobileMenuOpen = !isMobileMenuOpen;

        if (isMobileMenuOpen) {
            navMenu.classList.add('active');
            mobileOverlay.classList.add('active');
            // Lock body scroll - iOS Safari fix
            body.style.overflow = 'hidden';
            body.style.position = 'fixed';
            body.style.width = '100%';
        } else {
            navMenu.classList.remove('active');
            mobileOverlay.classList.remove('active');
            // Unlock body scroll - iOS Safari fix
            body.style.overflow = '';
            body.style.position = '';
            body.style.width = '';
            closeAllAccordions(); // Close all accordions when menu closes
        }
    }

    /**
     * Close Mobile Menu
     */
    function closeMobileMenu() {
        if (isMobileMenuOpen) {
            isMobileMenuOpen = false;
            navMenu.classList.remove('active');
            mobileOverlay.classList.remove('active');
            // Unlock body scroll - iOS Safari fix
            body.style.overflow = '';
            body.style.position = '';
            body.style.width = '';
            closeAllAccordions();
        }
    }

    /**
     * Toggle Mobile Accordion
     * Only one accordion open at a time
     */
    function toggleAccordion(navItem) {
        const isActive = navItem.classList.contains('active');

        // Close all accordions first
        closeAllAccordions();

        // If it wasn't active, open it
        if (!isActive) {
            navItem.classList.add('active');
        }
    }

    /**
     * Close All Accordions
     */
    function closeAllAccordions() {
        navItemsWithDropdown.forEach(item => {
            item.classList.remove('active');
        });
    }

    /**
     * Check if viewport is mobile
     */
    function isMobile() {
        return window.innerWidth <= 768;
    }

    /**
     * Handle Window Resize
     */
    function handleResize() {
        if (!isMobile() && isMobileMenuOpen) {
            closeMobileMenu();
        }
    }

    /**
     * Event Listeners
     */

    // Mobile toggle button (in nav)
    if (mobileToggle) {
        mobileToggle.addEventListener('click', toggleMobileMenu);
    }

    // Mobile toggle button (in header)
    if (mobileToggleHeader) {
        mobileToggleHeader.addEventListener('click', toggleMobileMenu);
    }

    // Overlay click to close
    if (mobileOverlay) {
        mobileOverlay.addEventListener('click', closeMobileMenu);
    }

    // Accordion click (only on mobile)
    navItemsWithDropdown.forEach(navItem => {
        const navLink = navItem.querySelector('.nav-link');
        
        if (navLink) {
            navLink.addEventListener('click', function(e) {
                if (isMobile()) {
                    e.preventDefault();
                    toggleAccordion(navItem);
                }
            });
        }
    });

    // Handle window resize
    window.addEventListener('resize', handleResize);

    // Close menu on ESC key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && isMobileMenuOpen) {
            closeMobileMenu();
        }
    });

    /**
     * Initialize
     */
    console.log('Navigation system initialized');
})();

